<template>
	<div class="access-record">
		<filter-panel
			class="keyword-filter-panel"
			:data="groups"
			labelWidth="80px"
			:simple="true"
			@search="filterChange"
		>
		</filter-panel>
		<el-row type="flex" :gutter="20">
			<el-col :span="8">
				<client-module
					moduletitle="平均排名"
					:hideBorder="true"
					class="oneBox"
					:isShowDetail="true"
				>
					<el-tooltip slot="event" placement="top">
						<div slot="content" v-html="avgTipText"></div>
						<ig-icon name="tishi" />
					</el-tooltip>
					<rank-card :argRankAndkeyWordInfo="argRankAndkeyWordInfo" :type="'avg'"></rank-card>
				</client-module>
			</el-col>
			<el-col :span="16">
				<client-module moduletitle="排名趋势" class="oneBox" :isShowDetail="true">
					<el-tooltip slot="event" placement="top">
						<div slot="content" v-html="chartTipText"></div>
						<ig-icon name="tishi" />
					</el-tooltip>
					<div class="scan-time">最近一次扫描时间：{{ argRankAndkeyWordInfo.taskDate }}</div>
					<keywordRankingLine :data="clientSource" charts-type="skyLine"></keywordRankingLine>
				</client-module>
			</el-col>
		</el-row>
		<el-row type="flex" :gutter="20" style="margin-top: 20px">
			<el-col :span="12">
				<client-module
					moduletitle="关键词排名"
					:hideBorder="true"
					class="oneBox keyword_box"
					:showTitle="true"
					:isShowTitle="true"
					:hint="true"
					:tipText="keywordTipText"
				>
					<rank-card :argRankAndkeyWordInfo="argRankAndkeyWordInfo" :type="'keyword'"></rank-card>
				</client-module>
			</el-col>
			<el-col :span="12">
				<client-module moduletitle="有排名关键词国家地区前三" :hideBorder="true" class="oneBox">
					<rank-card :countryList="countryList" :type="'country'"></rank-card>
				</client-module>
			</el-col>
		</el-row>
		<el-row type="flex" :gutter="20" style="margin-top: 20px">
			<client-module moduletitle=" " :hideBorder="true" class="oneBox">
				<sky-tabs v-model="tabValue" :tabList="tabList" class="rank-tab">
					<div class="view-more" @click="viewMore">查看更多</div>
				</sky-tabs>
				<data-list
					:table-style="{ name: 'webclient' }"
					:data="keywordList"
					:columns="columns"
					class="keyword-list"
					v-if="tabValue === 'top20'"
				></data-list>
				<data-list
					:table-style="{ name: 'webclient' }"
					:data="rankUrlList"
					:columns="rankUrlColumns"
					size="medium"
					class="keyword-list"
					v-if="tabValue === 'rankUrl'"
				></data-list>
			</client-module>
		</el-row>
	</div>
</template>
<script>
import keywordRankingLine from '@/components/client/clientCharts/keyword-ranking-line.vue';
import clientModule from '@/components/client/clientModule/clientModule';
import rankCard from '@/components/crm/crm-rank-card.vue';
import keywordRanking from '@/backend/services/keywordRanking/keywordRanking.js';
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';

export default {
	data() {
		const that = this;
		return {
			picVisible: false,
			clientSource: {
				columns: ['taskDate', 'rankingAvg'],
				rows: [],
				height: '300px',
				chartSettings: {
					labelMap: {
						rankingAvg: '平均排名',
					},
				},
				// 图例配置
				legend: {
					show: true,
					name: '平均排名',
					icon: 'circle', // 图例icon
					textStyle: {
						color: '#666666',
					},
					itemHeight: 8, //图例icon大小
					bottom: 15, // 图例位置
					selectedMode: false,
				},
				toolTip: {
					show: true,
					trigger: 'axis',
					backgroundColor: 'rgba(0, 0, 0, .75)',
				},
        yAxis: {
					inverse: true,
				},
			},
			argRankAndkeyWordInfo: {
				keywordList: [],
				taskDate: ''
			},
			countryList: [],
			keywordList: [],
			columns: [
				{
					label: '关键词',
					bind: 'keywords',
					align: 'left',
					type: 'percentage',
					showOverflowTooltip: true,
					width: '200',
					style: {
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						overflow: 'hidden',
					},
					dataStyle(val) {
						return val;
					},
				},
				{
					label: '国家地区',
					bind: 'geoLocation',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '排名',
					bind: 'ranking',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: ' 设备',
					bind: 'device',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						let obj = {
							'MOBILE': '移动',
							'PC': 'PC'
						}
						return obj[val] || '-'; 
					},
				},
				{
					label: '页面链接',
					bind: 'landingPageUrl',
					align: 'left',
					type: 'percentage',
					showOverflowTooltip: true,
					style: {
						color: '#3DA1FF',
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						overflow: 'hidden',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '快照',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					width: '200',
					bind() {
						let arr = [
							{
								text: '查看',
								trigger(row) {
									that.getPictureInfo(row.taskInstanceResultId);
								},
							},
						];

						return arr;
					},
				},
			],
			rankUrlList: [],
			rankUrlColumns: [
				{
					label: '页面链接',
					bind: 'landingPageUrl',
					align: 'left',
					type: 'percentage',
					showOverflowTooltip: true,
					style: {
						color: '#3DA1FF',
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						overflow: 'hidden',
					},
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '有排名的关键词数量',
					align: 'left',
					type: 'btnClick',
					style: 'text',
					width: '250',
					bind(row) {
						let arr = [
							{
								text: row.rankingCount,
								style: { color: '#333333' },
								trigger(row) {
									that.$router.push({
										path: 'keywordRanking',
										query: { tabs: 'detailedData', landingPageUrl: row.landingPageUrl },
									});
								},
							},
						];

						return arr;
					},
				},
			],
			tabList: [
				{
					label: '前20名关键词',
					name: 'top20',
				},
				{
					label: '有关键词排名链接',
					name: 'rankUrl',
				},
			],
			tabValue: 'top20',
			avgTipText:
				'平均排名是指在搜索引擎中输入关键词后，通过搜索引擎搜索到的结果页面中，该网站在该关键词下的排名的平均值。平均排名数值越小代表网站被搜索到靠前的关键词越多。</br>影响关键词排名的因素包括网站内容质量、关键词选择和密度、网站结构和内部链接、网站速度和性能、外部链接和社交媒体、HTTPS、品牌知名度和用户体验等因素。',
			chartTipText:
				'排名趋势：通常情况下，关键词排名的变化是正常的。搜索引擎的算法会不断地更新，这可能会导致关键词排名的变化。此外，竞争对手的行动也可能会影响您的关键词排名。</br>如果您的网站出现了排名下降，可能是因为网站内容质量下降、关键词竞争度增加、网站结构优化不当、外部链接减少；</br>如果您的网站出现了排名波动，可能是竞争对手排名变化、搜索算法更新、网站内容更新、网站技术问题、季节性因素等。',
			keywordTipText:
				'关键词排名是指在搜索引擎中输入关键词后，通过搜索引擎搜索到的结果页面中，该网站在该关键词下的排名。 排名数值越小代表越靠前。',
			groups: {
				others: [
					{
						tagName: 'sky-span',
						data: '最近一次扫描时间：' ,
						col: 21,
					},
					{
						tagName: 'sky-select',
						placeholder: ' 设备',
						col: 3,
						prop: 'device',
						value: '',
						options: [
							{
								label: '全部',
								value: '',
							},
							{
								label: 'PC',
								value: 'PC',
							},
							{
								label: '移动端',
								value: 'MOBILE',
							},
						],
					},
				],
			},
		};
	},
	props: {
		serviceSiteId: {
			type: String,
			default: '',
		},
	},
	components: {
		keywordRankingLine,
		clientModule,
		rankCard,
		skyTabs,
		filterPanel
	},
	watch: {
		serviceSiteId: {
			handler(val) {
				if (val) {
					this.init(val);
				}
			},
		},
		'$route.query': {
			handler() {
				this.init(this.serviceSiteId);
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		// 初始化
		init(serviceSiteId) {
			if (!serviceSiteId) return;
			this.getCountryList(serviceSiteId);
			this.getArgTamkKeywordInfo(serviceSiteId);
			this.getTop10List(serviceSiteId);
			this.getKeywordUrlList(serviceSiteId);
			this.getServiceEchartList(serviceSiteId);
		},
		// 获取国家和地区的排名
		async getCountryList(serviceSiteId) {
			try {
				let params = {
					size: 3,
					device: this.groups.others[1].value ? [this.groups.others[1].value] : ['PC', "MOBILE"]
				};
				let { data } = await keywordRanking.getGeoSerpList(params, serviceSiteId);
				this.countryList = data;
				let x = 1,
					y = 2;
				this.countryList.splice(
					x - 1,
					1,
					...this.countryList.splice(y - 1, 1, this.countryList[x - 1])
				);
			} catch (error) {
				console.log(error);
				this.countryList = [];
			}
		},
		// 获取平均排名和有关键词的排名
		async getArgTamkKeywordInfo(serviceSiteId) {
			try {
				let params = {
					device: this.groups.others[1].value ,
					serviceSiteId: serviceSiteId
				}
				let { data } = await keywordRanking.getArgRankAndKey(params);
				this.argRankAndkeyWordInfo = data ? data : {
					taskDate: '--'
				};
				let list = [];
				if (this.argRankAndkeyWordInfo.rankingTop5Count && this.argRankAndkeyWordInfo.rankingTop5Count !== 0) {
					list.push({
						name: '前5',
						rankCountComparison: this.argRankAndkeyWordInfo.rankingTop5CountComparison,
						rankingCount: this.argRankAndkeyWordInfo.rankingTop5Count,
						rank: 5,
					});
				}
				if (this.argRankAndkeyWordInfo.rankingTop10Count && this.argRankAndkeyWordInfo.rankingTop10Count !== 0) {
					list.push({
						name: '前10',
						rankCountComparison: this.argRankAndkeyWordInfo.rankingTop10CountComparison,
						rankingCount: this.argRankAndkeyWordInfo.rankingTop10Count,
						rank: 10,
					});
				}
				if (this.argRankAndkeyWordInfo.rankingTop20Count && this.argRankAndkeyWordInfo.rankingTop20Count !== 0) {
					list.push({
						name: '前20',
						rankCountComparison: this.argRankAndkeyWordInfo.rankingTop20CountComparison,
						rankingCount: this.argRankAndkeyWordInfo.rankingTop20Count,
						rank: 20,
					});
				}
				if (this.argRankAndkeyWordInfo.rankingTop50Count && this.argRankAndkeyWordInfo.rankingTop50Count !== 0) {
					list.push({
						name: '前50',
						rankCountComparison: this.argRankAndkeyWordInfo.rankingTop50CountComparison,
						rankingCount: this.argRankAndkeyWordInfo.rankingTop50Count,
						rank: 50,
					});
				}
				this.argRankAndkeyWordInfo.keywordList = list;
				this.groups.others[0].data = '最近一次扫描时间：' + this.argRankAndkeyWordInfo.taskDate;
			} catch (error) {
				console.log(error);
				this.argRankAndkeyWordInfo.keywordList = [];
			}
		},
		// 获取前10名关键词列表
		async getTop10List(serviceSiteId) {
			try {
				let params = {
					displayStart: 1,
					displayLength: 20,
					device: this.groups.others[1].value ? [this.groups.others[1].value] : ['PC', "MOBILE"]
				};
				let { data } = await keywordRanking.getTop10Keyword(params, serviceSiteId);
				this.keywordList = data.data;
			} catch (error) {
				console.log(error);
				this.keywordList = [];
			}
		},
		// 有关键词排名链接
		async getKeywordUrlList(serviceSiteId) {
			try {
				let params = {
					size: 20,
					device: this.groups.others[1].value ? [this.groups.others[1].value] : ['PC', "MOBILE"]
				};
				let { data } = await keywordRanking.getKeywordUrlRank(params, serviceSiteId);
				this.rankUrlList = data;
			} catch (error) {
				console.log(error);
				this.rankUrlList = [];
			}
		},
		// 查看快照
		async getPictureInfo(taskInstanceResultId) {
			let { data } = await keywordRanking.getviewPicture({
				taskInstanceResultId,
			});
			this.$emit('getPictureInfo', data);
		},
		// 查看图表排名趋势
		async getServiceEchartList(serviceSiteId) {
			try {
				let params = {
					size: 6,
					device: this.groups.others[1].value ? [this.groups.others[1].value] : ['PC', "MOBILE"]
				};
				let { data } = await keywordRanking.getServiceEchart(params, serviceSiteId);
				this.clientSource.rows = data;
			} catch (error) {
				console.log(error);
				this.clientSource.rows = [];
			}
		},
		// 查看更多
		viewMore() {
			this.$router.push({ path: 'keywordRanking', query: { tabs: 'detailedData', ranking: 10 } });
		},
		filterChange(val) {
			this.init(this.serviceSiteId);
		}
	},
};
</script>
<style lang="scss" scoped>

::v-deep  .keyword-filter-panel.filterPanel .filterMultiple .row {
	justify-content: space-between;
	font-size: 14px;
	padding-left: 24px;
}
.oneBox {
	background: #ffffff;
	border-radius: 4px;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
}

.access-record {
	margin-top: 20px;
}

.scan-time {
	font-size: 14px;
	font-weight: 400;
	color: #333333;
	line-height: 20px;
	margin: 24px 20px 0 24px;
}

.keyword-list {
	margin: 20px 0;
}

.view-more {
	font-size: 14px;
	font-weight: 400;
	color: #3da1ff;
	line-height: 20px;
	text-align: center;
	cursor: pointer;
	margin: 10px 0;
	white-space: nowrap;
}

::v-deep  .webclient-header th {
	padding: 8px 0;

	.cell {
		font-size: 14px;
		padding-left: 25px;
	}
}

::v-deep  .webclient-style {
	td {
		padding: 8px 0;
		padding-left: 15px;
	}
}
::v-deep  .rank-tab {
	border-bottom: 1px solid #e8e8e8;
	display: flex;
	align-items: center;
	justify-content: space-between;
	.el-tabs__active-bar {
		height: 1px;
	}
	.el-tabs__item {
		height: auto;
		line-height: 22px;
		padding: 17px 20px;
	}
}
::v-deep .module-main {
	height: calc(100% - 54px);
}

::v-deep.keyword_box {
	.top-title {
		.iconfont {
			color: #5aa0ff;
			font-weight: normal;
			user-select: none;
			cursor: pointer;
		}
	}
}
</style>
